import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TableFilter } from '@trnsact/trnsact-shared-types';
import { Nullable, TabsOption } from 'global';

import { FinanceTable } from './ui/components/FinanceTable';
import { FinanceFilters } from '../filters';
import { FinanceListTabsType, FinanceTableColumn } from './types';

export const convertFiltersToTabs = (
  tableFilters: TableFilter[],
  onDelete: (tf: TableFilter) => void,
  columns: FinanceTableColumn[],
  currentFilterConfig: Nullable<Partial<FinanceFilters>>,
  onAggregatedMetricsChange: (metrics: {
    productsSoldCount: number;
    totalAftermarketProfit: number;
    totalFinanceInsuranceProfit: number;
  }) => void
): TabsOption<FinanceListTabsType>[] => {
  return tableFilters.map(tf => ({
    label: tf.name,
    value: tf.tableFilterId as FinanceListTabsType,
    component: (
      <FinanceTable
        columns={columns}
        currentFilterConfig={currentFilterConfig}
        onAggregatedMetricsChange={onAggregatedMetricsChange}
      />
    ),
    iconEnd: (
      <IconButton
        onClick={e => {
          e.stopPropagation();
          onDelete(tf);
        }}
        color="primary"
        size="small"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    ),
  }));
};
